import config from '@utils/config/env';
import { format } from 'date-fns';

export async function googleSignUp(redirectUrl = '', token?: string) {
  const encodedMetadata = {},
    tos_acceptance = {
      data: format(new Date(), `yyyy-MM-dd'T'HH:mm:ss.SSSxxx`),
    };
  window.open(
    `${
      config.backendBaseUrl
    }/v1/auth/renter/google/signup/?metadata=${encodedMetadata}&tos_acceptance=${tos_acceptance}&redirect=${redirectUrl}${
      token ? `&token=${token}` : ''
    }`,
    '_self'
  );
}
